import typography from 'material-ui/styles/typography';
import { white } from 'material-ui/styles/colors';
import * as muiThemes from '../themes/muiThemes';

const themes = {
  darkBlueTheme: {
    headerItemBoxShadow: 'rgb(26, 26, 26) 0px 5px 10px',
    logoBackgroundColor: '#003968',
    logoColor: typography.textFullWhite,
    headerItemColor: white,
    headerItemBackgroundColor: '#003968',
    headerItemFontWeight: '100',
    selectedMenuListItemColor: '#ffffff',
    selectedMenuListItemBackgroundColor: '#EF6A00',
    selectedListItemColor: white,
    selectedListItemBackgroundColor: '#EF6A00',
    menuItemColor: '#e7e8e9 ',
    menuItemBackgroundColor: '#003968',
    avatarSpanColor: '#003968',
    avatarSpanTextShadow: '1px 1px #444',
    appBarMenuButtonColor: '#ffffff',
    settingsOptionsColor: '#ffffff'
  }
};

export const getTheme = (themeName) => themes[themeName];

export const getMuiTheme = (themeName) => muiThemes[themeName];
